import * as tslib_1 from "tslib";
import { BaseAPI } from '@app/core/class/baseAPI.class';
import { HttpClient } from '@angular/common/http';
var DepartmentService = /** @class */ (function (_super) {
    tslib_1.__extends(DepartmentService, _super);
    function DepartmentService(httpClient) {
        var _this = _super.call(this, httpClient) || this;
        _this.httpClient = httpClient;
        _this.endpoint = '/mock/departments.json';
        _this.apiFieldsMap = {};
        _this.fieldsRequired = [];
        return _this;
    }
    return DepartmentService;
}(BaseAPI));
export { DepartmentService };
